export default {
  path: "businessEntity",
  name: "Business Entity",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      component: () => import("@/views/entity/Index.vue"),
    },
    {
      path: "createEntity",
      name: "Create Entity",
      component: () => import("@/views/entity/CreateEntity.vue"),
    },
    {
      path: "view_entity/:id",
      name: "View Business Entity",
      component: () => import("@/views/entity/view-entity/Index"),
    },
    {
      path: "edit_entity/:id",
      name: "Edit Business Entity",
      component: () => import("@/views/entity/UpdateEntity"),
    },
    {
      path: "officeactivitylog",
      name: "Business Entity Transaction History",
      component: () =>
        import("@/views/entity/view-entity/Activity/ActivityLog"),
    },
    {
      path: "entitytreeview",
      name: "Business Entity Tree View",
      component: () => import("@/views/entity/EntityTreeView.vue"),
    },
    {
      path: "view_ticket/:entityId/:id",
      name: "View Ticket",
      component: () => import("@/views/entity/view-entity/tickets/ViewTicket"),
    },
    {
      path: "agreement/:entityId",
      name: "Agreement",
      component: () => import("@/views/entity/view-entity/Agreement"),
    },
  ],
};
